import { API } from '@/config'
import { getUser } from '@/core/auth'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'

export default {
  install(Vue) {
    const url = API.BASE_URL + '/wokerServiceHub'

    const userHub = new Vue()
    Vue.prototype.$userHub = userHub

    var connection = new HubConnectionBuilder()
      .withUrl(url,
        {
          accessTokenFactory: () => getUser().then((res) => res.access_token),

        })
      .configureLogging(LogLevel.Information)
      .build()

    Vue.prototype.$sendMessage = function sendMessage() {
      connection
        .invoke('SendMessage', '', 'Test Method Signal')
        .catch((err) => {
          /* eslint-disable no-debugger, no-console */
          console.log(`Error on connection.invoke(): ${err.toString()}`)
        })
      /* eslint-disable no-debugger, no-console */
      console.log('Message sent')
    }

    try {
      connection.on('ReceiveMessage', function (respose) {
        /* eslint-disable no-debugger, no-console */

        console.log(
          JSON.stringify(respose) +
          '----------------------------------On ReceiveMessage--------------------------------'
        )
        userHub.$emit('hub-recieve-status-queue', { respose })
      })
    } catch (err) {
      /* eslint-disable no-debugger, no-console */
      console.log(
        '----------------------------------Error ReceiveMessage--------------------------------' +
        err
      )
    }

    try {
      connection.on('DashboardsSourcesUpdate', function (respose) {
        /* eslint-disable no-debugger, no-console */

        console.log(
          JSON.stringify(respose) +
          '----------------------------------On DashboardsSourcesUpdate--------------------------------'
        )

        userHub.$emit('hub-recieve-status-updated-dashboard', { respose })
      })
    } catch (err) {
      /* eslint-disable no-debugger, no-console */
      console.log(
        '----------------------------------Error DashboardsSourcesUpdate--------------------------------' +
        err
      )
    }

    try {
      connection.on('ReceiveQueueReportMessage', function (respose) {
        userHub.$emit('hub-receive-status-queue-report', { respose })
      })
    } catch (err) {
      /* eslint-disable no-debugger, no-console */
      console.log(
        '----------------------------------Error ReceiveQueueReportMessage--------------------------------' +
        err
      )
    }

    // if connection closed, reopen it
    let startedPromise = null
    function start() {
      startedPromise = connection
        .start()
        .then(function () {
          /* eslint-disable no-debugger, no-console */
          console.log(
            '----------------------------------Starting Hub--------------------------------'
          )
        })
        .catch((err) => {
          /* eslint-disable no-debugger, no-console */
          console.log(
            '----------------------------------Error Starting Hub--------------------------------' +
            err
          )
          return new Promise((resolve, reject) =>
            setTimeout(
              () =>
                start()
                  .then(resolve)
                  .catch(reject),
              5000
            )
          )
        })
      return startedPromise
    }

    connection.onclose(() => start())

    start()
  },
}
